import { api } from './axios';
import type { OverallRanking } from '../types/results';

/**
 * Admin endpoint pro celkove poradi - vidi vzdy bez ohledu na overall_ranking_visible flag.
 * Pouziva STEJNY public endpoint ale s adminskou cookie - DB query je stejna, ale zde
 * potrebujeme bypass viditelnosti pres dedikovany /admin/competitions/{id}/overall.
 */
export const adminResultsApi = {
  overall: (competitionId: number) =>
    api.get<OverallRanking[]>(`/admin/competitions/${competitionId}/overall`).then((r) => r.data),
};
